class BESSAppProjectDwellingsEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.#updateTotals();
    }


    updateState() {
        super.updateState();
        this.#updateTotals();
    }

    #updateTotals() {
        this.totalDwellings = 0;
        this.totalArea = 0;
        this._forEachItem(this.#updateTotalsForItem);

        let totalsContent =
            this._createTotalItemContent(this.totalDwellings, this.editor.data.getWhat(this.totalDwellings)) +
            this._createTotalItemContent(this.editor.data.items.length,
                pluralise(this.editor.data.what + " group",
                    this.editor.data.what + " groups",
                    this.editor.data.items.length)) +
            this._createTotalItemContent(this.totalArea, "Total area (Square Meters)");

        this.editor.showTotals(totalsContent);
    }

    #updateTotalsForItem(item) {
        let quantity = item.inputs.quantity.getIntValue(0);
        let area = item.inputs.area.getIntValue(0);

        let itemTotalArea = quantity * area;
        this.totalDwellings += quantity;
        this.totalArea += itemTotalArea;
    }
}